{
  "comment": "M7 spec §16.6 (S3 owns): the FR station boot logs (source frStationBootLog, outsideBudget true): outside the clue budget, never a required lead or proof (T33). Ids start 'boot.'. Five logs: the last shift roster, a family's evacuation slot 'reassigned', a settlement lead to a colony ruin, one evacuation corroboration (link order) and the generated station manifest (texture). Each is a template: {station} is the restarted station's FR-### name, filled at runtime. Log shape: src/story/schemas.ts evidenceLogSchema. Names, codes and dates are placeholders until the naming pass (spec §15 item 7).",
  "logs": [
    {
      "id": "boot.last_shift_roster",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Last shift roster",
      "date": "CY10 d207",
      "source": "frStationBootLog",
      "body": "{station} · OPERATIONS ROSTER · CY10 d207 · night shift\nPosted by the duty officer. Nobody signed the relief column.",
      "table": {
        "columns": ["Post", "On shift", "Relieved by"],
        "rows": [
          ["Reactor", "G. Amsel", ""],
          ["Air plant", "T. Varga, Y. Varga", ""],
          ["Dock control", "N. Pell", ""],
          ["Comms", "B. Okoro (listening for the gate board)", ""],
          ["Galley", "whoever's left", ""]
        ]
      },
      "words": [],
      "fromTier": 1,
      "outsideBudget": true,
      "template": true
    },
    {
      "id": "boot.slot_reassigned",
      "thread": "evacuation",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Evacuation slot notice",
      "date": "CY10 d205",
      "source": "frStationBootLog",
      "body": "{station} · RESIDENTS' BOARD · EVACUATION SLOTS\nPrinted notice, pinned. Someone has written under the last line in grease pencil: \"They said they'd call it. Nobody called it. We're in the galley if it changes.\"",
      "table": {
        "columns": ["Household", "Persons", "Slot", "Status"],
        "rows": [
          ["Amsel", "3", "window d204", "boarded"],
          ["Okoro", "5", "window d204", "boarded"],
          ["Varga", "4", "window d206", "reassigned"],
          ["Pell", "2", "window d206", "reassigned"]
        ]
      },
      "words": [],
      "fromTier": 1,
      "outsideBudget": true,
      "template": true
    },
    {
      "id": "boot.colony_survey_lead",
      "thread": "settlement",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Claim survey dispatch",
      "date": "CY9 d310",
      "source": "frStationBootLog",
      "body": "{station} · REGISTRY DISPATCH · outbound, never sent\nTo: Charter Registry, gate office\nRe: proof of working operation, colony claim, outer belt\nThe colony at the fix below has run its air plant and its ore line for one year. Claim papers attached. Please register before the next survey.\nTransmit queue: held. Gate office not answering.",
      "words": [],
      "lead": { "systemHint": "fr-colony-ruin", "poiKind": "ruin" },
      "fromTier": 1,
      "outsideBudget": true,
      "template": true
    },
    {
      "id": "boot.gate_window_allocation",
      "thread": "evacuation",
      "link": "order",
      "kind": "proof",
      "weight": 1,
      "title": "Gate window allocation, dock control",
      "date": "CY10 d206",
      "source": "frStationBootLog",
      "body": "{station} · DOCK CONTROL · GATE WINDOW ALLOCATION · as received from Gate Control\nThe station's own hull was booked for window d206. The board changed at 04:10.",
      "table": {
        "columns": ["Window", "Booked", "Auth", "As changed 04:10", "Auth"],
        "rows": [
          ["d206 02:00", "{station} shuttle, 31 persons", "GC", "TH-0586", "OPS-R/7"],
          ["d206 05:30", "SL Hesper Line", "GC", "TH-0478", "OPS-R/7"],
          ["d211 09:00", "-", "", "{station} shuttle, 31 persons", "GC"]
        ]
      },
      "words": [],
      "fromTier": 1,
      "outsideBudget": true,
      "template": true
    },
    {
      "id": "boot.station_manifest",
      "thread": "settlement",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Station manifest at shutdown",
      "date": "CY10 d212",
      "source": "frStationBootLog",
      "body": "{station} · AUTOMATIC MANIFEST AT SHUTDOWN\nWritten by the station core when the last reactor loop went cold.\nRegistered under the First Charter. Prime contractor mark on file.",
      "table": {
        "columns": ["Stores", "Count"],
        "rows": [
          ["Ration packs", "0"],
          ["Filters, scrubber grade", "0"],
          ["Suits, pressure", "11 of 40 racked"],
          ["Persons aboard at shutdown", "0"]
        ]
      },
      "words": [],
      "fromTier": 1,
      "outsideBudget": true,
      "template": true
    }
  ]
}
